import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';

var Area =
/** @class */
function (_super) {
  __extends(Area, _super);

  function Area() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'area';
    return _this;
  }
  /**
   * 获取 折线图 默认配置
   */


  Area.prototype.getDefaultOptions = function (options) {
    var _a;

    var xField = options.xField;
    return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
      tooltip: {
        showMarkers: true,
        showCrosshairs: true,
        crosshairs: {
          type: 'x'
        }
      },
      meta: (_a = {}, _a[xField] = {
        type: 'cat',
        range: [0, 1]
      }, _a),
      isStack: true,
      // 默认开启
      line: {},
      legend: {
        position: 'top-left'
      }
    });
  };
  /**
   * 获取 面积图 的适配器
   */


  Area.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Area;
}(Plot);

export { Area };